import { Fragment } from "react";
import { NavLink } from "react-router-dom";
// import { withStyles } from "@mui/styles";
import { List, ListItem } from "@mui/material";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
});

function ResultDetails(props) {
  let deviceListDetails = props.deviceListDetails;
  const deviceList = deviceListDetails
    ? deviceListDetails.map((device, i) => (
        <ListItem key={i}>
          <Fragment>
            <NavLink to={"/device/" + device} className="Nav_link">
              {device}
            </NavLink>
          </Fragment>
        </ListItem>
      ))
    : null;

  if ((!deviceList || deviceList.length) === 0) {
    return <h3>No search results</h3>;
  } else {
    return (
      <div>
        {deviceListDetails && deviceList.length !== 0 ? (
          <div>
            <List>{deviceList}</List>
          </div>
        ) : null}
      </div>
    );
  }
}

// export default withStyles(styles, { withTheme: true })(ResultDetails);
export default ResultDetails